export default __webpack_public_path__ + "static/media/senti.waterworks.black.b11473f4.svg";